/**
 * Service Discovery Types
 *
 * Type definitions for the service discovery system.
 * Adapted from the browser extension implementation.
 */
/**
 * Service relation types used in .well-known/service-configuration
 */
export const SERVICE_RELS = {
    IDENTITY_PROVIDER: 'https://airia.ai/rel/identity-provider',
    API: 'https://airia.ai/rel/api',
    OFFICE: 'https://airia.ai/rel/office',
    MCP_GATEWAY: 'https://airia.ai/rel/mcp-gateway',
    CHAT: 'https://airia.ai/rel/chat',
};
/**
 * Storage keys used by the service discovery system
 */
export const STORAGE_KEYS = {
    SELECTED_REGION: 'airia-selected-region',
    CUSTOM_APP_URL: 'airia-custom-app-url',
    SERVICE_CONFIG_CACHE: 'airia-service-config-cache',
    REDIRECT_ATTEMPTED: 'airia-redirect-attempted',
};
